module.exports = __webpack_public_path__ + "media/images/emblems/Vernier-coat_of_arms-969b55e70402a2d001455140fe8b5e7b.svg";